define('SessionKeepAlive.EntryPoint', [
  'SessionKeepAlive.Settings',
  'SessionKeepAlive.Controller',
  'Utils'
], function (
  Settings,
  SessionKeepAliveController,
  Utils
) {
  'use strict';

  var controller = null;

  function getLogoutUrl(environment) {
    var touchpoints = environment.getSiteSetting && environment.getSiteSetting('touchpoints');
    return touchpoints && touchpoints.logout;
  }

  return {
    mountToApp: function mountToApp(container) {
      var environment = container.getComponent('Environment');
      var userProfile = container.getComponent('UserProfile');

      if (!environment || !userProfile || controller) {
        return;
      }

      if (environment.isPageGenerator && environment.isPageGenerator()) {
        return;
      }

      var settings = Settings.read(environment);
      if (!settings.enabled) {
        return;
      }

      userProfile.getUserProfile().then(function (profile) {
        if (!profile || profile.isloggedin !== true || profile.isguest === true || !profile.internalid) {
          return;
        }

        controller = new SessionKeepAliveController({
          settings: settings,
          customerId: profile.internalid,
          logoutUrl: getLogoutUrl(environment),
          pingUrl: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
              'Modules/SessionKeepAlive/SuiteScript2/SessionKeepAlive.Service.ss'
            ), true
          )
        });
        controller.start();
      });
    }
  };
});
